const bankPrefixes = [
  {
    faName: "ملی ایران",
    enName: "melli iran",
    prefix: ["603799"],
    svgAddress: require("@/assets/svg/bankSvg/melli.svg"),
    mainColor: "rgb(247,167,11, 0.8)",
  },
  {
    faName: "سپه",
    enName: "sepah",
    prefix: ["589210"],
    svgAddress: require("@/assets/svg/bankSvg/sepah.svg"),
    mainColor: "rgb(79,79,79, 0.8)",
  },
  {
    faName: "توسعه صادرات",
    enName: "tose-e saaderat",
    prefix: ["627648", "207177"],
    svgAddress: "",
    mainColor: "",

  },
  {
    faName: "صنعت و معدن",
    enName: "sanat va madan",
    prefix: ["627961"],
    svgAddress: require("@/assets/svg/bankSvg/sanat.svg"),
    mainColor: "rgb(168,139,83, 0.8)",
  },
  {
    faName: "کشاورزی",
    enName: "keshavarzi",
    prefix: ["603770", "639217"],
    svgAddress: require("@/assets/svg/bankSvg/keshavarzi.svg"),
    mainColor: "rgb(224,214,109, 0.8)",
  },
  {
    faName: "مسکن",
    enName: "maskan",
    prefix: ["628023"],
    svgAddress: require("@/assets/svg/bankSvg/maskan.svg"),
    mainColor: "rgb(247,89,32, 0.8)",
  },
  {
    faName: "پست بانک",
    enName: "post bank",
    prefix: ["627760"],
    svgAddress: require("@/assets/svg/bankSvg/post-bank-iran.svg"),
    mainColor: "rgb(153,212,32, 0.8)",
  },
  {
    faName: "توسعه تعاون",
    enName: "tose-e taavon",
    prefix: ["627884"],
    svgAddress: require("@/assets/svg/bankSvg/tose-taavon.svg"),
    mainColor: "rgb(10,137,146, 0.8)",
  },
  {
    faName: "اقتصاد نوین",
    enName: "eghtesad-e novin",
    prefix: ["627412"],
    svgAddress: require("@/assets/svg/bankSvg/eghtesad.svg"),
    mainColor: "rgb(112,30,114, 0.8)",
  },
  {
    faName: "پارسیان",
    enName: "parsian",
    prefix: ["622106", "639194", "627884"],
    svgAddress: require("@/assets/svg/bankSvg/parsian.svg"),
    mainColor: "rgb(150,18,27, 0.8)",
  },
  {
    faName: "پاسارگاد",
    enName: "pasargad",
    prefix: ["502229", "639347"],
    svgAddress: require("@/assets/svg/bankSvg/pasargad.svg"),
    mainColor: "rgba(0,0,0,0.8)",
  },
  {
    faName: "کارآفرین",
    enName: "karafarin",
    prefix: ["627488", "502910"],
    svgAddress: require("@/assets/svg/bankSvg/karafarin.svg"),
    mainColor: "rgb(21,114,21, 0.8)",
  },
  {
    faName: "سامان",
    enName: "saman",
    prefix: ["621986"],
    svgAddress: require("@/assets/svg/bankSvg/saman.svg"),
    mainColor: "rgb(2,170,232, 0.8)",
  },
  {
    faName: "سینا",
    enName: "sina",
    prefix: ["639346"],
    svgAddress: require("@/assets/svg/bankSvg/sina.svg"),
    mainColor: "rgb(25,73,156, 0.8)",
  },
  {
    faName: "سرمایه",
    enName: "Sarmaye",
    prefix: ["639607"],
    svgAddress: require("@/assets/svg/bankSvg/sarmaye.svg"),
    mainColor: "rgb(33,75,106, 0.8)",
  },
  {
    faName: "شهر",
    enName: "shahr",
    prefix: ["502806", "504706"],
    svgAddress: require("@/assets/svg/bankSvg/shahr.svg"),
    mainColor: "rgb(223,52,58, 0.8)",
  },
  {
    faName: "دی",
    enName: "dey",
    prefix: ["502938"],
    svgAddress: require("@/assets/svg/bankSvg/dey.svg"),
    mainColor: "rgb(0,138,159, 0.8)",
  },
  {
    faName: "صادرات",
    enName: "saaderat",
    prefix: ["603769"],
    svgAddress: require("@/assets/svg/bankSvg/saderat.svg"),
    mainColor: "rgb(41,22,111, 0.8)",
  },
  {
    faName: "ملت",
    enName: "melat",
    prefix: ["610433", "991975"],
    svgAddress: require("@/assets/svg/bankSvg/mellat.svg"),
    mainColor: "rgb(237,71,81, 0.8)",
  },
  {
    faName: "تجارت",
    enName: "tejarat",
    prefix: ["585983"],
    svgAddress: require("@/assets/svg/bankSvg/tejarat.svg"),
    mainColor: "rgb(46,66,141, 0.8)",
  },
  {
    faName: "رفاه",
    enName: "refah",
    prefix: ["589463"],
    svgAddress: require("@/assets/svg/bankSvg/refah.svg"),
    mainColor: "rgb(0,75,127, 0.8)",
  },
  {
    faName: "انصار",
    enName: "ansar",
    prefix: ["627381"],
    svgAddress: require("@/assets/svg/bankSvg/ansar.svg"),
    mainColor: "rgb(198,57,59, 0.8)",
  },
  {
    faName: "مهر اقتصاد",
    enName: "mehr-e eghtesad",
    prefix: ["639370"],
    svgAddress: require("@/assets/svg/bankSvg/mehreghtesad.svg"),
    mainColor: "rgb(75,201,125, 0.8)",
  },
  {
    faName: "ایران زمین",
    enName: "iran zamin",
    prefix: ["505785"],
    svgAddress: require("@/assets/svg/bankSvg/iranzamin.svg"),
    mainColor: "rgba(96,38,161,0.8)",
  },
  {
    faName: "آینده",
    enName: "ayandeh",
    prefix: ["636214", "686214"],
    svgAddress: require("@/assets/svg/bankSvg/ayande.svg"),
    mainColor: "rgb(82,45,29, 0.8)",

  },
  {
    faName: "حمکت ایرانیان",
    enName: "hekmat iranian",
    prefix: ["636949"],
    svgAddress: require("@/assets/svg/bankSvg/hekmat.svg"),
    mainColor: "rgb(1,91,120, 0.8)",

  },
  {
    faName: "مهر ایران",
    enName: "mehr iran",
    prefix: ["606373"],
    svgAddress: "",
    mainColor: "",

  },
  {
    faName: "قوامین",
    enName: "ghavamin",
    prefix: ["639599"],
    svgAddress: require("@/assets/svg/bankSvg/ghavamin.svg"),
    mainColor: "rgb(0,146,81, 0.8)",


  },
  {
    faName: "گردشگری",
    enName: "gaedeshgari",
    prefix: ["505416"],
    svgAddress: require("@/assets/svg/bankSvg/gardeshgari.svg"),
    mainColor: "rgb(176,17,23, 0.8)",

  },
  {
    faName: "موسسه اعتباری توسعه",
    enName: "etebari tose-e",
    prefix: ["628157"],
    svgAddress: require("@/assets/svg/bankSvg/etebari-tosee.svg"),
    mainColor: "rgb(137,31,26, 0.8)",

  },
  {
    faName: "موسسه اعتباری کوثر",
    enName: "etebari kosar",
    prefix: ["505801"],
    svgAddress: require("@/assets/svg/bankSvg/kosar.svg"),
    mainColor: "rgb(146,5,9, 0.8)",

  },
  {
    faName: "موسسه اعتباری نور",
    enName: "Noor Credit Institution",
    prefix: ["507677"],
    svgAddress: require("@/assets/svg/bankSvg/noor.svg"),
    mainColor: "rgb(1,79,154, 0.8)",

  },
  {
    faName: " قرض الحسنه رسالت",
    enName: "gharz al-hasane resalat",
    prefix: ["504172"],
    svgAddress: require("@/assets/svg/bankSvg/resalat.svg"),
    mainColor: "rgb(0,154,174, 0.8)",

  },
  {
    faName: "خاورمیانه",
    enName: "khavarmiyane",
    prefix: ["585947"],
    svgAddress: require("@/assets/svg/bankSvg/khavarmiane.svg"),
    mainColor: "rgb(241,146,0, 0.8)",

  },
  {
    faName: "ایران ونزوئلا",
    enName: "iranvenezula",
    prefix: ["581874"],
    svgAddress: "",
    mainColor: "",

  },
  {
    faName: "موسسه ملل",
    enName: "melal",
    prefix: ["606256"],
    svgAddress: "",
    mainColor: "",

  },
  {
    faName: "دماوند",
    enName: "DAMAVAND",
    prefix: ["672022"],
    svgAddress: "",
    mainColor: "",

  },
];

export default bankPrefixes;
